import React, { ReactNode } from 'react';
import './index.css';

interface Props {
    columns: {
        id?: string | number,
        name: string,
        header: string,
        width: string,
        align?: "center" | "left" | "right",
        color?: string,
        bold?: boolean,
        hidden?: boolean,
        renderCell?: any
    }[],
    data: any[],
    onCLick?: Function,
    rowLink?: boolean
}

const HHClickList: React.FC<Props> = (props) => {

    return (
        <div className='hh-clicklist'>
            <div className='header'>
                {
                    props.columns.filter(x => x.hidden !== true).map((c, i) => {
                        return !c.hidden && (
                            <div
                                key={i}
                                style={{
                                    width: c.width,
                                    textAlign: c.align || "left",
                                    color: c.color || "black",
                                    fontWeight: c.bold ? "bold" : "normal"
                                }}
                            >
                                {c.header}
                            </div>
                        )
                    })
                }
            </div>
            <div className="body">
                {
                    props.data.map((d, i) => {
                        return (
                            <div
                                key={i}
                                className='row'
                                onClick={props.onCLick ? props.onCLick(d) : undefined}
                                style={{ 
                                    background: d.background ? d.background : "",
                                    display: (d.hidden) ? "none" : "flex",
                             }}
                            >
                                {
                                    props.columns.filter(x => x.hidden !== true).map((c, i) => {

                                        return (
                                            <div
                                                key={i}
                                                className='cell'
                                                style={{
                                                    width: c.width,
                                                    textAlign: c.align || "left",
                                                    color: c.color || "black",
                                                    fontWeight: c.bold ? "bold" : "normal",

                                                }}
                                            >
                                                {
                                                    c.renderCell
                                                        ? c.renderCell(d)
                                                        : d[c.name]
                                                }
                                            </div>)
                                    })
                                }
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default HHClickList;